import { makeAutoObservable } from "mobx";
import {
  PresaleTransaction,
  PresaleTransactionsData,
  TransactionsData,
} from "../types/types";
import { StatisticsData } from "../types/types";

class RecentExchangesStore {
  exchangesData: TransactionsData = {};
  presaleExchangesData: PresaleTransactionsData = {
    count: 0,
    transactions: {},
    total_alfa: 0,
    total_usd: 0,
  };
  diagramData: StatisticsData | undefined = undefined;
  loading: boolean = true;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchLitsExchanges() {
    this.loading = true;
    try {
      const response = await window.fetch(
        "/api/v1/exchange/last-transactions",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      this.exchangesData = data;
      this.loading = false;
    } catch {
      console.log("Failed to fetch location data");
    }
  }

  async fetchPresaleLitsExchanges() {
    this.loading = true;
    try {
      const response = await window.fetch(
        "/api/v1/presale/last-transactions",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      this.presaleExchangesData = data;
      this.loading = false;
    } catch {
      console.log("Failed to fetch location data");
    }
  }

  async fetchDiagramData() {
    this.loading = true;
    try {
      const response = await window.fetch(
        "/api/v1/exchange/diagram-data",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      this.diagramData = data;
      this.loading = false;
    } catch {
      console.log("Failed to fetch location data");
    }
  }
}

const recentExchangesStore = new RecentExchangesStore();
export default recentExchangesStore;
